import * as React from 'react';
import {MockupList} from '../../../../node_modules/argo-ui';

export class Loading extends React.Component {
    public render() {
        return <MockupList />;
    }
}
